import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { api } from "../api/apiSlice";
import authReducer from "../features/auth/authSlice";
import branchFilterReducer from "../features/branchFilter/branchFilterSlice";

// Only auth (the JWT + identity) survives a reload. Everything else
// (roles, permissions, module data) lives in the RTK Query cache and is
// re-fetched from the API, so it can never go stale in storage.
const persistConfig = {
  key: "texasalarms-web",
  storage,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  branchFilter: branchFilterReducer,
  [api.reducerPath]: api.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(api.middleware),
});

export const persistor = persistStore(store);
